import { ComponentProps } from 'react';
import { Link, useParams } from 'react-router';

import { routes } from '@fly/shared';
import { BreadcrumbComponent } from '@fly/shared-ui';
import { Link as RadixLink } from '@radix-ui/themes';

export const ArtifactVersionsBreadcrumb: BreadcrumbComponent = ({
  isLast,
}: ComponentProps<BreadcrumbComponent>) => {
  const { artifactName } = useParams();

  return isLast ? (
    <RadixLink className='text-fly-general-black'>
      <strong>{artifactName}</strong>
    </RadixLink>
  ) : (
    <RadixLink asChild color='gray'>
      <Link className='font-semibold' to={routes.DASHBOARD.REGISTRY.ARTIFACTS}>
        {artifactName}
      </Link>
    </RadixLink>
  );
};
